<template>
  <div v-if="isOpen" class="call-popup">
    <Transition name="fade">
      <span
        v-show="isOpen"
        class="call-popup__bg"
        @click="closeModal"
      ></span>
    </Transition>

    <Transition name="slide-up">
      <div v-show="isOpen" class="call-popup__sheet">
        <div class="call-popup__header">
          <p class="call-popup__title">Позвонить в дилерский центр</p>
          <button
            type="button"
            class="call-popup__close"
            aria-label="Закрыть"
            @click="closeModal"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 5L19 19M19 5L5 19"
                stroke="#A5A5A5"
                stroke-width="2.25"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>

        <template v-for="(center, index) in callCenters" :key="center.phone_number">
          <div class="call-popup__item">
            <p class="call-popup__street">
              <span><img src="@/img/icons/map_bullit-g.svg" alt="" /></span>
              {{ center.street }}
            </p>
            <a
              :href="`tel:${center.phone_number}`"
              class="call-popup__phone"
              @click="closeModal"
              >{{ center.phone_text }}</a
            >
          </div>
          <div
            v-if="index < callCenters.length - 1"
            class="call-popup__divider"
          ></div>
        </template>
      </div>
    </Transition>
  </div>
</template>

<script>
import siteData from "@/config.json";

export default {
  name: "CallPopupComponent",
  data() {
    return {
      callCenters: siteData.call_centers,
      isOpen: false,
    };
  },
  methods: {
    closeModal() {
      this.isOpen = false;
    },
  },
  mounted() {
    this.emitter.on("open-call-popup", (data) => {
      this.isOpen = data.open;
    });
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active {
  transition: all 0.3s ease-out;
}

.slide-up-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
